<div class="p-2">
    <div class="modal-header justify-content-between align-items-center">
    <h4 class="modal-title">Device Info</h4>
    <button
        type="button"
        class="accello-icon-btn close-circle"
        (mousedown)="isActive = true"
        (mouseup)="isActive = false"
        (mouseleave)="isActive = false"
        (click)="activeModal.dismiss('Cross click')"
    >
        <img
        [src]="isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'"
        alt="close"
        />
    </button>
    </div>

    <div class="modal-body di-body">

    <!-- Row: Device Name | Device Type -->
    <div class="di-row">
        <div class="di-cell">
        <span class="di-label">Device Name</span>
        <span class="di-value fw-bold">{{ device?.deviceName || '-' }}</span>
        </div>
        <div class="di-cell">
        <span class="di-label">Device Type</span>
        <span class="di-badge" [ngClass]="getBadgeClass(device?.deviceType)">
            {{ device?.deviceType || '-' }}
        </span>
        </div>
    </div>

    <!-- Row: Environment | Serial Number (LOCAL) / Remote Environment (REMOTE) -->
    <div class="di-row">
        <div class="di-cell">
        <span class="di-label">Environment</span>
        <span class="di-value fw-bold">{{ getEnvironmentLabel() }}</span>
        </div>
        <div class="di-cell">
        <ng-container *ngIf="isLocal(); else remoteEnv">
            <span class="di-label">Device Serial Number</span>
            <span class="di-value fw-bold">{{ device?.serialNumber || '-' }}</span>
        </ng-container>
        <ng-template #remoteEnv>
            <span class="di-label">Remote Environment</span>
            <span class="di-value fw-bold">{{ device?.remoteEnvironment || '-' }}</span>
        </ng-template>
        </div>
    </div>

    <!-- Row: Platform | Platform Version -->
    <div class="di-row">
        <div class="di-cell">
        <span class="di-label">Platform</span>
        <span class="di-value fw-bold di-platform">
            <img
            *ngIf="getPlatformIcon()"
            [src]="getPlatformIcon()"
            alt="platform"
            class="di-platform-icon"
            />
            {{ device?.platform || '-' }}
        </span>
        </div>
        <div class="di-cell">
        <span class="di-label">Platform Version</span>
        <span class="di-value fw-bold">{{ device?.platformVersion || '-' }}</span>
        </div>
    </div>

    <!-- LOCAL: Automation Port | Host -->
    <ng-container *ngIf="isLocal()">
        <div class="di-row">
        <div class="di-cell">
            <span class="di-label">Automation Port</span>
            <span class="di-value fw-bold">{{ device?.automationPort || '-' }}</span>
        </div>
        <div class="di-cell">
            <span class="di-label">Host</span>
            <span class="di-value fw-bold">{{ device?.automationHost || '-' }}</span>
        </div>
        </div>
    </ng-container>

    <!-- REMOTE: Username | Access Key -->
    <ng-container *ngIf="!isLocal()">
        <div class="di-row">
        <div class="di-cell">
            <span class="di-label">Username</span>
            <span class="di-value fw-bold">{{ device?.credentials?.username || device?.username || '-' }}</span>
        </div>
        <div class="di-cell">
            <span class="di-label">Access Key</span>
            <div class="d-flex align-items-center gap-2">
                <span class="di-value fw-bold di-ellipsis">
                    {{ showPassword['accessKey'] ? (device?.credentials?.accessKey || device?.accessKey || '-') : getMaskedAccessKey() }}
                </span>
                <span
                    class="ms-2 cursor-pointer material-symbols-outlined eye-visibility"
                    (click)="toggleAccessKeyVisibility()"
                    [title]="showPassword['accessKey'] ? 'Hide Access Key' : 'Show Access Key'" (keydown.enter)="toggleAccessKeyVisibility()">
                    {{ showPassword['accessKey'] ? "visibility_off" : "visibility" }}
                </span>
            </div>
        </div>
        </div>
    </ng-container>

    <!-- Connected Execution Engine (full-width) -->
    <div class="di-row">
        <div class="di-cell full-width">
        <span class="di-label">Connected Execution Engine</span>
        <span class="di-value fw-bold">{{ device?.agentName || device?.agentId || '-' }}</span>
        </div>
    </div>

    <!-- REMOTE: Remote Options table -->
    <ng-container *ngIf="!isLocal() && getRemoteOptions().length">
        <div class="di-section-label">Remote Options</div>
        <app-zorro-table
        tableId="di-remote-options"
        class="w-100"
        [columns]="remoteOptionsColumns"
        [data]="getRemoteOptions()"
        [options]="remoteOptionsTableOptions"
        ></app-zorro-table>
    </ng-container>

    </div>

</div>